import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Chip } from "@mui/material";
import axios from "axios";
const SentRequest = ({
  user,
  name,
  desg,
  price,
  logo,
  profile,
  slot,
  status,
  id,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  if (status !== "pending") {
    //&& user.Id!=result.fromId
    return;
  }
  //   const timeDuration=(slot)=>{
  //     let text = slot
  // const myArray = text.split(" ");
  // const arr1=myArray[0].split(":")
  // const arr2=myArray[3].split(":")
  // const h1=parseInt(arr1[0]);
  // const h2=parseInt(arr2[0]);
  // const m1=parseInt(arr1[1]);
  // const m2=parseInt(arr2[1]);
  // return (60*(h2-h1)+(m2-m1))
  //   }
  return (
    <>
      <div className="relative w-full overflow-hidden bg-white box-shadow-request-card grid grid-cols-4 rounded-lg my-4 p-2">
        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Sent 15 Min ago</p>
        </div>
        <div className="border-r border-gray-400 my-auto col-span-1">
          <img
            src={require("../../../images/photo.png")}
            className="h-32 rounded-full border-2 border-black p-1 block mx-auto"
            alt="Profile"
          />
          <button className="view-profile-card-btn w-4/5 mt-2 mx-auto">
            View Profile
          </button>
        </div>
        <div className="px-3 col-span-3">
          <div className="flex py-1 justify-between w-full">
            <div className="w-12 h-12 logo-shadow mx-1 rounded-lg">
              <img src={require("../../../images/amazon.png")} alt="google" />
            </div>
            <div className="text-center">
              <h4 className="text-2xl font-medium leading-4">{name}</h4>
              <p>{desg}</p>
            </div>
            <div className="flex gap-2">
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                <i className="fa-solid fa-bookmark"></i>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                <i className="fa-solid fa-share"></i>
              </div>
            </div>
          </div>
          <div
            className="flex justify-between text-center my-1 gap-x-1 mx-2"
            style={{ alignItems: "flex-start" }}
          >
            <div>
              <p className="text-base text-gray-400">Profile</p>
              <Chip
                label={profile}
                color="info"
                sx={{ fontWeight: "medium" }}
              />
            </div>
            <div>
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">INR 299</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Session Duration</p>
              <p className="text-lg">30 Min</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Interview Slot</p>
              <p className="text-lg">[{slot}]</p>
              <p className="text-lg">20 June, 2022</p>
            </div>
          </div>
          <div className="relative flex justify-center">
            <p className="text-green-700 font-medium text-lg border-2 px-2 py-1 rounded">
              <i className="fa-solid fa-check"></i> Request Sent
            </p>
            <div className="cancel-dropdown-cont">
              <div className="cancel-dropdown flex">
                <i className="fa-solid fa-caret-right"></i>
              </div>
              <button className="cust-btn cancel-btn" onClick={handleClickOpen}>
                Cancel Request
              </button>
              <div>
                {/* <Button
                      variant="outlined"
                      onClick={handleClickOpen}
                    >
                      Cancel
                    </Button> */}
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {"Use Google's location service?"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Let Google help apps determine location. This means
                      sending anonymous location data to Google, even when no
                      apps are running.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => {
                        axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/delete/${id}`);
                      }}
                      autoFocus
                    >
                      YES
                    </Button>
                    <Button onClick={handleClose}>NO</Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SentRequest;
